import React from 'react';
import { Button } from 'antd';
import style from './style.module.css';

const TabButtons = ({
  inUserOverviewTab,
  editing,
  handleClick,
  loading,
  isProjectLoaded,
}) => {
  return (
    <div className={style.buttonWrapper}>
      {editing && !inUserOverviewTab && (
        <Button
          type="danger"
          className={style.spacer}
          value={'delete'}
          onClick={(e) => handleClick(e.target.value)}
        >
          Usuń
        </Button>
      )}
      {editing && (
        <Button
          type="default"
          className={style.spacer}
          value={'cancel'}
          onClick={(e) => handleClick(e.target.value)}
        >
          Anuluj
        </Button>
      )}
      {editing ? (
        <Button
          type="primary"
          className={style.spacer}
          disabled={!editing}
          value="save"
          onClick={(e) => handleClick(e.target.value)}
          loading={loading}
        >
          {/* <Icon type="plus" /> */}
          Zachowaj
        </Button>
      ) : (
        <Button
          type="default"
          className={style.spacer}
          disabled={!isProjectLoaded}
          value={'edit'}
          onClick={(e) => handleClick(e.target.value)}
        >
          Edytuj
        </Button>
      )}
    </div>
  );
};

export default TabButtons;
